$(function () {
  const ctx = document.getElementById('myChart');

  const chart = new Chart(ctx, {
    type: 'line',
    margin: [100, 100, 100, 100],
    data: {
      labels: history.labels,
      datasets: [{
        label: 'パワーランク',
        data: history.data,
        backgroundColor: [
          // 'rgba(255, 99, 132, 0.2)',
          // 'rgba(54, 162, 235, 0.2)',
          // 'rgba(255, 206, 86, 0.2)',
          // 'rgba(75, 192, 192, 0.2)',
          // 'rgba(153, 102, 255, 0.2)',
          // 'rgba(255, 159, 64, 0.2)'
          '#ffe03c'
        ],
        borderColor: [
          // 'rgba(255, 99, 132, 1)',
          // 'rgba(54, 162, 235, 1)',
          // 'rgba(255, 206, 86, 1)',
          // 'rgba(75, 192, 192, 1)',
          // 'rgba(153, 102, 255, 1)',
          // 'rgba(255, 159, 64, 1)'
          '#2560AA'
        ],
        borderWidth: 2,
        pointBackgroundColor: "#2561aa93",
        radius: 5,
        pointHoverBackgroundColor: "#2560AA",
        pointHoverRadius: 7,
      }]
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: { //軸の設定
        yAxes: [{ //Y軸の設定
          ticks: { //目盛りの設定
            beginAtZero: true, //開始値を0
            min: 0, //最小値
            max: 100 //最大値
          },
        }]
      },
    },
  })
});